'use client'

import { useAuthStore } from '@/lib/stores/auth-store'
import { useThemeStore } from '@/lib/stores/theme-store'
import dynamic from 'next/dynamic'

// Dynamic import para evitar SSR issues e melhorar performance inicial
const CopilotWidget = dynamic(
  () => import('@/components/copilot/copilot-widget'),
  { ssr: false }
)

/**
 * CopilotGlobalProvider
 *
 * Renderiza o widget do copilot globalmente para usuários autenticados.
 * O widget só aparece se o mentor tiver o copilot habilitado.
 */
export function CopilotGlobalProvider() {
  const { user, isAuthenticated } = useAuthStore()
  const { currentTheme, isBlockStatusVerified } = useThemeStore()

  // Só renderizar se usuário estiver autenticado e a área estiver verificada/disponível.
  if (!isAuthenticated || !user?.id || !isBlockStatusVerified || currentTheme?.member_area_blocked) {
    return null
  }

  // Pegar mentor ID do tema atual
  const mentorId = currentTheme?.mentor_id
  if (!mentorId) {
    return null
  }

  return (
    <CopilotWidget
      mentorId={mentorId}
      clientId={user.id}
    />
  )
}
